// firebase-config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuração do Firebase
// ATENÇÃO: Substitua pelos seus dados reais do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBFkl3lAIMuWVR7LO9fn6vQPNsDAUodlrE",
  authDomain: "juristask.firebaseapp.com",
  projectId: "juristask",
  storageBucket: "juristask.firebasestorage.app",
  messagingSenderId: "211682119277",
  appId: "1:211682119277:web:a7d617244940ac09e23964",
  measurementId: "G-K2MYQB59DK"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar serviços
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// ID da aplicação para organização dos dados
export const appId = "juristask-v1";

export default app;